import { Component } from '@angular/core';

@Component({
  selector: 'app-marketdata',
  imports: [],
  templateUrl: './marketdata.html',
  styleUrl: './marketdata.scss',
})
export class Marketdata {

}
